//NiceSelect.bind(document.getElementById("filterSeries"));
//NiceSelect.bind(document.getElementById("filterSort"));

//NiceSelect.bind(document.getElementById("downloadType"));
//NiceSelect.bind(document.getElementById("downloadFormat"));

//   Slide Filter
$(".btn-filter-slide").click(function () {
    $(".filter-slide").animate({ right: "0px" }, 200);
});
$('.close-filter').click(function() {
    $('.filter-slide').animate({right: "-420px"}, 200);
});


/** INSTALLATION GUIDE ISOTOPE FILTER **/
var $grid = $(".install-guide-grid").isotope({
    itemSelector: ".grid-item",
    //percentPosition: true,
	layoutMode: 'fitRows',
    /*masonry: {
        columnWidth: ".grid-sizer",
    },*/
});

function setGridCategory() {
    $(".install-guide-grid").isotope({ filter: filterValue });
}

// var $installGuideSearch = $(".installGuideSearch").keyup(
//     debounce(function () {
//         qsRegex = new RegExp($installGuideSearch.val(), "gi");
//         $grid.isotope({
//             filter: function () {
//                 return qsRegex ? $(this).text().match(qsRegex) : true;
//             },
//         });
//     }, 200)
// );

function debounce(fn, threshold) {
    var timeout;
    return function debounced() {
        if (timeout) {
            clearTimeout(timeout);
        }

        function delayed() {
            fn();
            timeout = null;
        }
        timeout = setTimeout(delayed, threshold || 100);
    };
}

$(".navs-guide li a").click(function (e) {
    e.preventDefault();
    var filterValue = $(this).attr("data-filter");
    $grid.isotope({
        filter: filterValue,
    });
    $(".install-guide-search input").val("");
});

// $(".navs-guide").each(function (i, buttonGroup) {
//     var $buttonGroup = $(buttonGroup);
//     $buttonGroup.on("click", "a", function () {
//         $buttonGroup.find(".is-checked").removeClass("is-checked");
//         $(this).addClass("is-checked");
//         $("#installGuideSearchh").val("");
//     });
// });


// ISOTOPE PAGINATION
$(document).ready(function () {
    var itemSelector_1 = ".grid-item";
    var $container1 = $(".install-guide-grid");
    /*$container1.imagesLoaded(function () {
        $container1.isotope({
            itemSelector: itemSelector_1,
            masonry: {
                horizontalOrder: true,
            },
        });
    });*/


    var itemsPerPageDefault = 6;
    //var itemsPerPage = defineItemsPerPage();
    var itemsPerPage = 6;
    var currentNumberPages = 1;
    var currentPage = 1;
    var startPage = 1;
    var currentFilter = "*";
    var filterAtribute = "data-filter";
    var pageAtribute = "data-page";
    var pagerClass = "isotope-pager";

    function changeFilter(selector) {
        $container1.isotope({
            filter: selector,
        });
    }

    function goToPage(n) {
        currentPage = n;
        var selector = itemSelector_1;
        selector += "[" + pageAtribute + '="' + currentPage + '"]';
        changeFilter(selector);
    }

    function setPagination() {
        var SettingsPagesOnItems = (function () {
            var itemsLength = $container1.children(itemSelector_1).length;
            var pages = Math.ceil(itemsLength / itemsPerPage);
            var item = 1;
            var page = 1;
            var selector = itemSelector_1;
            selector += currentFilter != "*" ? "[" + filterAtribute + '="' + currentFilter + '"]' : "";

            $container1.children(selector).each(function () {
                if (item > itemsPerPage) {
                    page++;
                    item = 1;
                }
                $(this).attr(pageAtribute, page);
                item++;
            });
            currentNumberPages = page;
        })();

        var CreatePagers = (function () {
            var $isotopePager = $("." + pagerClass).length == 0 ? $('<div class="' + pagerClass + '"></div>') : $("." + pagerClass);

            $isotopePager.html("");

            var $page_prev_btn = $('<a type="button" class="previous_btn"></a>');

            var $page_next_btn = $('<a type="button" class="next_btn"></a>');
            $page_prev_btn.appendTo($isotopePager);

            for (var i = 0; i < currentNumberPages; i++) {
                var $pager = $('<a href="javascript:void(0);" class="pager" ' + pageAtribute + '="' + (i + 1) + '"></a>');
                $pager.html(i + 1);

                $pager.click(function () {
                    var page = $(this).eq(0).attr(pageAtribute);
                    $(".isotope-pager a").removeClass("active");
                    $(this).addClass("active");
                    goToPage(page);
                });

                $pager.appendTo($isotopePager);
                $isotopePager.find("a.pager:first").addClass("active");
            }

            $page_next_btn.appendTo($isotopePager);
            $container1.after($isotopePager);

            $page_prev_btn.click(function () {
                if (currentPage > startPage) {
                    $(".previous_btn").removeAttr("disabled");
                    var page = currentPage - 1;
                    var page = currentPage - 1 < startPage ? startPage : currentPage - 1;
                    $(".isotope-pager a").removeClass("active");
                    $('.pager[data-page="' + page + '"]').addClass("active");
                    goToPage(page);
                } else {
                    $(".previous_btn").attr("disabled", "disabled");
                }
            });
            $page_next_btn.click(function () {
                if (currentPage < currentNumberPages) {
                    $(".next_btn").removeAttr("disabled");
                    var page = currentPage + 1 > currentNumberPages ? currentNumberPages : currentPage + 1;
                    $(".isotope-pager a").removeClass("active");
                    $('.pager[data-page="' + page + '"]').addClass("active");
                    goToPage(page);
                } else {
                    $(".next_btn").attr("disabled", "disabled");
                }
            });
        })();
    }
    // setPagination();
    // goToPage(1);
});
/* END ISOTOPE */
  